let notifyCallback = null;

export function registerNotify(fn) {
  notifyCallback = fn;
}

export function notifyOnPage(targetPath, message, severity, autoHideDuration) {
  if (
    window.location.pathname.includes(targetPath) &&
    typeof notifyCallback === "function"
  ) {
    notifyCallback(message, severity, autoHideDuration);
  }
}
